import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout.js";
import eyeIcone from "../../assets/icons/eye-svgrepo-com.svg";
import shareIcone from "../../assets/icons/share-svgrepo-com.svg";
import iconeFacebook from "../../assets/icons/facebook-color-svgrepo-com.svg";
import iconeWhatsapp from "../../assets/icons/whatsapp-color-svgrepo-com.svg";
import SnackbarAlert from "../../components/SnackbarAlert.js";
import { Link, NavLink, useNavigate, useParams } from "react-router";
import Carousel from "react-multi-carousel";
import {
  getproductById,
  listeDesproduct,
  VisitorCompteurproduct
} from "../../services/produits/ProduitsRequest.js";
import { PiWhatsappLogoBold } from "react-icons/pi";
import { useDispatch } from "react-redux";
import { addFavorite } from "../../features/favorites/FavoritesSlices.js";
import { ThreeDots } from "react-loader-spinner";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 4,
    partialVisibilityGutter: 40
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 2,
    partialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 2,
    partialVisibilityGutter: 30
  }
};

const ProductDetails = () => {
  // shows marker on London by default
  const navigate = useNavigate();
  const { id } = useParams();
  // État pour chaque unité
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 6,
    nombrePage: 1,
    pagePagination: 1
  });
  const [loadingAutresProduit, setLoadingAutresProduit] = useState(false);

  const [articles, setArticles] = useState([
    {
      name: "Samsung Galaxy S23 Ultra",
      description:
        "Smartphone haut de gamme avec un écran AMOLED 120 Hz et un appareil photo 200 MP.",
      prix: 119900,
      stock: 10,
      enSoldes: true,
      prixPromotionnel: 109900,
      reduction: 8.34,
      promotionFash: 10,
      categorie: "Téléphone",
      marque: "Samsung",
      images: [
        "https://i.pinimg.com/736x/0c/d8/4d/0cd84d84c4c3842771c5c0fa9d44faa0.jpg",
        "https://i.pinimg.com/236x/ae/86/1c/ae861c9a8139c3ca5b1097adaf886317.jpg",
        "https://i.pinimg.com/236x/64/7a/58/647a587b0255c714a7b94b6995aa0bc9.jpg",
        "https://i.pinimg.com/736x/bc/c2/4d/bcc24d484db99457d18aa41ec7eba24f.jpg",
        "https://i.pinimg.com/236x/2d/a8/c5/2da8c59d8e26548079a67769fab11a56.jpg",
        "https://i.pinimg.com/236x/ef/99/65/ef996542a1bb55c3d4f97928fa198276.jpg"
      ]
    }
  ]);

  const [imagesProduit, setImagesProduit] = useState([]);

  const [detailsProduct, setDetailsProduct] = useState([]);

  const [selectedImage, setSelectedImage] = useState();

  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const [sendFavoris, setSendFavoris] = useState(false);
  const dispatch = useDispatch();

  const handleAddToFavorites = () => {
    setSendFavoris(true);

    const token = localStorage.getItem("compte_visiteur");
    if (!token) {
      setSendFavoris(false);
      document.getElementById("my_modal_2").showModal(); // Redirigez vers la page de connexion si besoin
      return;
    }

    // Remplacez promotionData par votre objet promotion réel
    dispatch(
      addFavorite({
        id: detailsProduct && detailsProduct._id, // ID unique de la promotion
        name: detailsProduct && detailsProduct.name,
        image: detailsProduct && detailsProduct.images[0],
        marqueName:
          detailsProduct && detailsProduct.marque && detailsProduct.marque.nom,
        pourcentage: detailsProduct && detailsProduct.pourcentageSolde,
        dateFin: detailsProduct && detailsProduct.finSolde

        // ... autres propriétés
      })
    );

    setTimeout(() => {
      setSendFavoris(false);
      setSnackbarOpenSuccess(true);
      setSuccessMessage("Article ajouté aux favoris avec succès");

      // setSnackbarOpenSuccess();
    }, 5000);
  };

  // Fonction pour calculer la différence
  const calculateTimeLeft = (finSolde) => {
    const now = Date.now(); // timestamp actuel en ms
    const end = new Date(finSolde).getTime(); // timestamp de la date d’expiration
    // finSolde
    const difference = end - now; // ms restants

    if (difference > 0) {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      setTimeLeft({ days, hours, minutes, seconds, isExpired: false });
    } else {
      setTimeLeft({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        isExpired: true
      });
    }
  };

  const [articlesAutres, setArticlesAutres] = useState([]);

  const onSubmit = (id) => {
    const msg = `Bonjour je souhaiterai avoir plus d'information sur cet article et comment passer la commande svp https://www.godleadershop.ci/product-details/${id}`;
    const phoneWithCountryCode = "+2250564021616"; // Ensure the phone number includes the country code
    if (msg) {
      const url = `https://wa.me/${phoneWithCountryCode}?text=${encodeURIComponent(
        msg
      )}`;
      window.open(url, "_blank");
    } else {
      alert("Please insert message to send");
    }
  };

  const counterVisitorClick = (id) => {
    window.scrollTo(0, 0); // Scroll en haut
    VisitorCompteurproduct(id)
      .then((res) => {
        console.log(res.data);
        navigate(`/product-details/${id}`);
        console.log("compteur incrementé");
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      calculateTimeLeft(detailsProduct.finSolde);
    }, 1000); // Mise à jour chaque seconde

    // Nettoyage de l'intervalle à la fin
    return () => clearInterval(timer);
  }, [detailsProduct]);

  useEffect(() => {
    setLoadingAutresProduit(true);
    if (detailsProduct) {
      listeDesproduct(
        pageQuery.page,
        pageQuery.size,
        detailsProduct.categorie && detailsProduct.categorie.nom
      )
        .then((res) => {
          setLoadingAutresProduit(false);
          setArticlesAutres(res.data.products);
        })
        .catch((err) => {
          setLoadingAutresProduit(false);
          console.log("err :", err);
        });
    }
  }, [detailsProduct]);

  const filteredPromotions = articlesAutres.filter(
    (item) => item._id.toString() !== detailsProduct._id.toString()
  );

  useEffect(() => {
    if (id) {
      getproductById(id)
        .then((res) => {
          setDetailsProduct(res.data.product);
          const resData = res.data.product && res.data.product.images;
          setArticles(res.data.product);
          setImagesProduit(resData);
          // setIdFirstCategorie(resData.categorie && resData.categorie[0]._id);
        })
        .catch((err) => {
          console.log("Error while getting promotion", err);
          // TODO: handle error gracefully
        });
    }
  }, [id]);

  console.log("articles :", articles);

  useEffect(() => {
    if (imagesProduit) {
      setSelectedImage(imagesProduit[0]);
    }
  }, [imagesProduit]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll en haut
  }, []);

  return (
    <Layout>
      <div className="p-2 w-full">
        <div className="breadcrumbs flex flex-row justify-start w-full text-sm ">
          <ul>
            <li>
              <a href="/">Accueil</a>
            </li>

            <li>Détails article</li>
          </ul>
        </div>

        <div className="w-full ">
          <div className="flex flex-row gap-2 items-center">
            <div className="flex flex-row gap-4 w-full ">
              {/* Liste des miniatures */}
              <div className="bg-white hidden xl:flex rounded-md shadow-md  flex-col justify-start items-center gap-y-2">
                {detailsProduct.images &&
                  detailsProduct.images.map((image, i) => (
                    <button
                      key={i}
                      className={`p-1 ${selectedImage === image ? "border-2 border-primary" : ""
                        }`}
                      onClick={() => setSelectedImage(image)}
                    >
                      <img
                        src={image}
                        alt="Product-Image"
                        className="w-12 h-12 rounded-md"
                      />
                    </button>
                  ))}
              </div>

              <div className="bg-white  rounded-md shadow-md flex lg:flex-row xl:flex-row  md:flex-row flex-col  gap-4 w-full p-3 ">
                <div className="flex flex-col item-center gap-y-3 w-full ">
                  <div className="flex lg:flex-row md:flex-row xl:flex-row flex-col justify-between ">
                    <div className="flex lg:flex-row md:flex-row xl:flex-row flex-col gap-4 w-full">
                      <div className="xl:w-[320px] lg:w-[320px] w-full    h-[320px] flex  ">
                        <img
                          src={selectedImage}
                          alt="Product Banner"
                          className="w-full h-full object-contain rounded-md "
                        />
                      </div>
                      <div className="w-fit md:hidden lg:hidden xl:hidden flex rounded-md   flex-row justify-start items-center gap-2  ">
                        {detailsProduct.images &&
                          detailsProduct.images.map((image, i) => (
                            <button
                              key={i}
                              className={`p-1 ${selectedImage === image
                                  ? "border-2 border-primary"
                                  : ""
                                }`}
                              onClick={() => setSelectedImage(image)}
                            >
                              <img
                                src={image}
                                alt="Product-Image"
                                className="w-12 h-12 rounded-md"
                              />
                            </button>
                          ))}
                      </div>
                      <div className="flex flex-col justify-start w-fit  gap-y-4 relative">
                        <h2 className="text-slate-600">
                          <span className="text-xl font-semibold text-primary">
                            {detailsProduct && detailsProduct.marque
                              ? detailsProduct.marque.nom
                              : "--"}
                          </span>
                        </h2>
                        <h1 className="text-2xl font-bold text-gray-800">
                          {detailsProduct.name &&
                            detailsProduct.name.length > 20
                            ? detailsProduct.name.slice(0, 20) + "..."
                            : detailsProduct.name}{" "}
                        </h1>
                        <div className="">
                          <p className="text-md text-gray-600 xl:w-[500px] lg:w-[500px] md:w-[500px] w-[300px] truncate">
                            {detailsProduct.description}
                          </p>
                        </div>
                        {detailsProduct.pourcentageSolde && (
                          <span className="text-red-500 text-xl font-bold absolute top-0 xl:right-[15rem] lg:right-[15rem] md:right-[15rem] right-2">
                            - {detailsProduct.pourcentageSolde} %
                          </span>
                        )}
                        <div className="flex  xl:flex-row lg:flex-row  md:flex-row  flex-col  gap-2 justify-start items-start">
                          {/* <h2 className="text-gray-800 font-semibold text-lg">
                            {detailsProduct.prixSolde ? (
                              <h2>{detailsProduct.prixSolde} FCFA</h2>
                            ) : (
                              <h2>{detailsProduct.prix} FCFA</h2>
                            )}
                          </h2> */}
                          <h2 className="text-gray-800 font-semibold text-lg">
                            {detailsProduct.prixSolde ? (
                              <h2>
                                {detailsProduct.prix - detailsProduct.prixSolde}{" "}
                                FCFA
                              </h2>
                            ) : (
                              <h2>{detailsProduct.prix} FCFA</h2>
                            )}
                          </h2>
                          {detailsProduct.prixSolde && (
                            <del className="">{detailsProduct.prix} FCFA</del>
                          )}
                        </div>
                        {/* const now = Date.now(); // timestamp actuel en ms const
                        dateFinPromo = new Date(item.finSolde).getTime(); */}
                        {new Date(detailsProduct.finSolde).getTime() >
                          Date.now() && (
                            <div className="">
                              <h1 className="text-md font-semibold text-gray-800 text-wrap">
                                <span className="text-red-500 font-semibold">
                                  Fash promo
                                </span>{" "}
                                - expire dans :
                              </h1>
                              <div className="grid grid-flow-col gap-5 mt-2 text-center auto-cols-max">
                                <div className="flex flex-col p-2 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                                  <span className="countdown font-mono text-xl">
                                    <span
                                      style={{ "--value": timeLeft.days }}
                                    ></span>
                                  </span>
                                  Jrs
                                </div>

                                <div className="flex flex-col p-2 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                                  <span className="countdown font-mono text-xl">
                                    <span
                                      style={{ "--value": timeLeft.hours }}
                                    ></span>
                                  </span>
                                  Hrs
                                </div>

                                <div className="flex flex-col p-2 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                                  <span className="countdown font-mono text-xl">
                                    <span
                                      style={{ "--value": timeLeft.minutes }}
                                    ></span>
                                  </span>
                                  Min
                                </div>

                                <div className="flex flex-col p-2 bg-neutral rounded-lg justify-center items-center text-neutral-content">
                                  <span className="countdown font-mono text-xl">
                                    <span
                                      style={{ "--value": timeLeft.seconds }}
                                    ></span>
                                  </span>
                                  Sec
                                </div>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>

                    <div className="  xl:flex lg:flex hidden flex-col justify-end  xl:w-[230px] lg:w-[230px] md:w-[230px] w-full ">
                      <div className="flex flex-col gap-2">
                        <button
                          onClick={() => onSubmit(detailsProduct._id)}
                          className="border-[1px] bg-primary text-white flex flex-row justify-center items-center font-bold text-center py-2 w-full rounded-lg"
                        >
                          <span>commander</span>

                          <PiWhatsappLogoBold className="w-6" />
                        </button>
                        <button
                          onClick={handleAddToFavorites}
                          className="border-[1px] border-primary h-fit text-black font-bold  flex items-center justify-center text-center py-2 w-full rounded-lg hover:bg-primary hover:text-white"
                        >
                          {sendFavoris ? (
                            <ThreeDots
                              height="40"
                              width="40"
                              color="#397ad5"
                              radius="9"
                              ariaLabel="three-dots-loading"
                              wrapperStyle={{}}
                              wrapperClass=" h-fit "
                              visible={sendFavoris}
                            />
                          ) : (
                            " Ajouter aux favoris"
                          )}
                        </button>

                        <div className="flex flex-row gap-2">
                          <div className="dropdown dropdown-hover bg-gray-200 flex flex-row justify-start items-center gap-x-2 text-black font-bold text-center  w-full rounded-lg">
                            <div
                              tabIndex={0}
                              role="button"
                              className=" flex flex-row gap-x-1 px-4"
                            >
                              <img src={shareIcone} className="w-5" alt="" />
                              <span>Partager</span>
                            </div>
                            <ul
                              tabIndex={0}
                              className="dropdown-content flex flex-row  menu mb-[-5.5rem] bg-base-100 rounded-box z-[1]  py-2 px-6 shadow"
                            >
                              <div className="flex flex-row gap-x-4">
                                <a
                                  href={`https://www.facebook.com/share.php?u=${encodeURIComponent(
                                    window.location.href
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex flex-row text-black font-bold text-center py-2 w-full rounded-lg"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    window.open(
                                      `https://www.facebook.com/share.php?u=${encodeURIComponent(
                                        window.location.href
                                      )}`,
                                      "facebook-share-dialog",
                                      "width=626,height=436"
                                    );
                                  }}
                                >
                                  <img
                                    src={iconeFacebook}
                                    className="w-5"
                                    alt=""
                                  />
                                </a>

                                <a
                                  href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                                    `Découvrez cet article ${detailsProduct.name} avec ${detailsProduct.pourcentageSolde}% de réduction!\n${window.location.href}`
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex flex-row text-black font-bold text-center py-2 w-full rounded-lg"
                                >
                                  <img
                                    src={iconeWhatsapp}
                                    className="w-5"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </ul>
                          </div>
                          <div className="flex flex-row gap-x-4"></div>
                          <div className="bg-gray-200 flex flex-row justify-center items-cente gap-x-2 text-black font-bold text-center py-2 w-full rounded-lg">
                            <img src={eyeIcone} className="w-5" alt="" />
                            <span>
                              {detailsProduct.visitorCount
                                ? detailsProduct.visitorCount
                                : 0}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Liste des miniatures */}
                  <div className="flex md:flex-row flex-col gap-2 justify-between items-start xl:hidden ">
                    <div className="w-fit hidden md:flex rounded-md   flex-row justify-start items-center gap-2  ">
                      {detailsProduct.images &&
                        detailsProduct.images.map((image, i) => (
                          <button
                            key={i}
                            className={`p-1 ${selectedImage === image
                                ? "border-2 border-primary"
                                : ""
                              }`}
                            onClick={() => setSelectedImage(image)}
                          >
                            <img
                              src={image}
                              alt="Product-Image"
                              className="w-12 h-12 rounded-md"
                            />
                          </button>
                        ))}
                    </div>
                    <div className="flex flex-col justify-end  xl:w-[230px] lg:w-[230px] md:w-[230px] w-full ">
                      <div className="flex flex-col gap-2">
                        <button
                          onClick={() => onSubmit(detailsProduct._id)}
                          className="border-[1px] bg-primary text-white  flex flex-row justify-center items-center font-bold text-center py-2 w-full rounded-lg"
                        >
                          <span>commander</span>

                          <PiWhatsappLogoBold className="w-6" />
                        </button>
                        <button
                          c
                          onClick={handleAddToFavorites}
                          className="border-[1px] border-primary h-fit text-black font-bold  flex items-center justify-center text-center py-2 w-full rounded-lg hover:bg-primary hover:text-white"
                        >
                          {sendFavoris ? (
                            <ThreeDots
                              height="40"
                              width="40"
                              color="#397ad5"
                              radius="9"
                              ariaLabel="three-dots-loading"
                              wrapperStyle={{}}
                              wrapperClass=" h-fit "
                              visible={sendFavoris}
                            />
                          ) : (
                            " Ajouter aux favoris"
                          )}
                        </button>

                        <div className="flex flex-row gap-3">
                          <div className="dropdown dropdown-hover bg-gray-200 flex flex-row justify-center items-center gap-x-2 text-black font-bold text-center  w-full rounded-lg">
                            <div
                              tabIndex={0}
                              role="button"
                              className=" flex flex-row gap-x-2"
                            >
                              <img src={shareIcone} className="w-5" alt="" />
                              <span>Partager</span>
                            </div>
                            <ul
                              tabIndex={0}
                              className="dropdown-content flex flex-row  menu mb-[-5.5rem] bg-base-100 rounded-box z-[1]  py-2 px-6 shadow"
                            >
                              <div className="flex flex-row gap-x-4">
                                <a
                                  href={`https://www.facebook.com/share.php?u=${encodeURIComponent(
                                    window.location.href
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex flex-row text-black font-bold text-center py-2 w-full rounded-lg"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    window.open(
                                      `https://www.facebook.com/share.php?u=${encodeURIComponent(
                                        window.location.href
                                      )}`,
                                      "facebook-share-dialog",
                                      "width=626,height=436"
                                    );
                                  }}
                                >
                                  <img
                                    src={iconeFacebook}
                                    className="w-5"
                                    alt=""
                                  />
                                </a>

                                <a
                                  href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                                    `Découvrez cet article ${detailsProduct.name} avec ${detailsProduct.pourcentageSolde}% de réduction!\n${window.location.href}`
                                  )}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex flex-row text-black font-bold text-center py-2 w-full rounded-lg"
                                >
                                  <img
                                    src={iconeWhatsapp}
                                    className="w-5"
                                    alt=""
                                  />
                                </a>
                              </div>
                            </ul>
                          </div>
                          <div className="bg-gray-200 flex flex-row justify-center items-cente gap-x-2 text-black font-bold text-center py-2 w-full rounded-lg">
                            <img src={eyeIcone} className="w-5" alt="" />
                            <span className="text-black text-md">
                              {detailsProduct.visitorCount
                                ? detailsProduct.visitorCount
                                : 0}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div role="tablist" className="tabs w-full  tabs-lifted mt-[3rem] ">
            <input
              type="radio"
              name="my_tabs_2"
              role="tab"
              className="tab font-semibold text-md "
              aria-label="Fiche technique"
              defaultChecked
            />
            <div
              role="tabpanel"
              className="tab-content bg-base-100 border-base-300 rounded-box w-full  p-3"
            >
              <div className="overflow-x-auto w-full">
                <table className="table-auto w-full text-left">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2">Désignation</th>
                      <th className="px-4 py-2">Valeur</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailsProduct.specifications &&
                      detailsProduct.specifications.map((item, idx) => (
                        <tr
                          key={item._id || idx}
                          className={
                            idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="border px-4 py-2 w-">
                            <div className="">
                              {typeof item.spec === "object"
                                ? item.spec && item.spec.name
                                : item.spec}
                            </div>
                          </td>
                          <td className="border px-4 py-2 w-[80%] text-wrap">
                            {item.value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            <input
              type="radio"
              name="my_tabs_2"
              role="tab"
              className="tab font-semibold text-md "
              aria-label="Description"
              defaultChecked
            />
            <div
              role="tabpanel"
              className="tab-content bg-base-100 border-base-300 rounded-box p-3 "
            >
              <p>{detailsProduct.description}</p>
            </div>
          </div>

          <h3 className="text-gray-800 text-xl font-semibold mt-[4rem]">
            Produits similaires
          </h3>

          <div className="">
            <Carousel
              additionalTransfrom={0}
              arrows
              autoPlaySpeed={3000}
              centerMode={false}
              className=" py-8 "
              containerClass="container-with-dots"
              dotListClass=""
              draggable
              focusOnSelect={false}
              infinite
              itemClass=""
              keyBoardControl
              minimumTouchDrag={80}
              pauseOnHover
              renderArrowsWhenDisabled={false}
              renderButtonGroupOutside={false}
              renderDotsOutside={false}
              responsive={responsive}
              rewind={false}
              rewindWithAnimation={false}
              rtl={false}
              shouldResetAutoplay
              showDots={false}
              sliderClass=""
              slidesToSlide={1}
              swipeable
            >
              {filteredPromotions.map((item, i) => (
                <div
                  key={i}
                  onClick={() => counterVisitorClick(item._id)}
                  className="w-40 xl:w-64 lg:w-64 md:w-64 cursor-pointer   bg-white shadow-md flex flex-col justify-between pb-4 rounded-xl duration-500 hover:scale-105 hover:shadow-xl relative"
                >
                  <div className="">
                    <img
                      src={item.images[0]}
                      alt="Product"
                      className="h-60 w-full object-contain rounded-t-xl"
                    />
                    <div>
                      <div className="flex flex-row justify-between items-center px-4  w-40">
                        <span className="text-gray-400 mr-3 uppercase text-xs truncate">
                          {item.marque && item.marque.nom}
                        </span>
                      </div>
                      <div className="px-4 py-1 flex flex-col w-full ">
                        <h3 className="text-md font-medium truncate">
                          <span className="font-bold">{item.name}</span> -{" "}
                          {item.description}
                        </h3>
                      </div>
                      <div className="flex flex-col justify-between items-start px-4 py-1">
                        <h2 className="text-md text-secondary font-semibold">
                          {item.prixSolde ? (
                            <h2>{item.prix - item.prixSolde} FCFA</h2>
                          ) : (
                            <h2>{item.prix} FCFA</h2>
                          )}
                        </h2>
                        {item.prixSolde && (
                          <del className="">{item.prix} FCFA</del>
                        )}
                        <span className="text-gray-400 text-xs ">
                          {item.stock} en stock
                        </span>
                      </div>
                    </div>
                  </div>

                  {item.pourcentageSolde !== 0 && (
                    <h2 className="absolute top-1 right-1 text-md font-bold bg-[#7ace73c5] py-2 px-2 rounded-xl text-primary truncate block capitalize">
                      -{item.pourcentageSolde}%
                    </h2>
                  )}
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </div>

      <SnackbarAlert
        vertical={vertical}
        horizontal={horizontal}
        snackbarSuccessOpen={snackbarSuccessOpen}
        handleCloseSnackbarSuccess={handleCloseSnackbarSuccess}
        successMessage={successMessage}
        snackbarErrorOpen={snackbarErrorOpen}
        handleCloseSnackbarError={handleCloseSnackbarError}
        errorMessage={errorMessage}
      />
    </Layout>
  );
};

export default ProductDetails;
